import { Module, Mutation, Action } from "vuex-module-decorators";
import PaginationModule from "@/store/base-modules/PaginationModule";
import { RootState } from "@/store";
import { queryRequest } from "@/utils/request";
import {
  queryPatternForStock,
  queryHubDiameter,
  queryTyreInventoryQuantityList
} from "@/graphql/warehouse.gql";
import type { PaginationDataState } from "@/types";

export interface WarehouseStockModuleState extends PaginationDataState {
  searchCondition: any;
}

const defaultSearchInstance = () => ({
  keyword: ""
});
@Module({ name: "WarehouseStockModule", namespaced: true })
export default class WarehouseStockModule
  extends PaginationModule<WarehouseStockModuleState, RootState>
  implements WarehouseStockModuleState {
  public listData: any[] = [];
  public searchCondition: any = defaultSearchInstance(); // 筛选条件
  public openFilterFlag: boolean = false; // 打开筛选模块
  public filterData: any = []; // 筛选条件数据
  public hubDiameterData: string[] = []; // 尺寸数组

  @Mutation
  setHubDiameterDataMutation(data: any[]) {
    this.hubDiameterData = data || [];
  }
  @Mutation
  setFilterDataMutation(data: any[]) {
    this.filterData = data || [];
  }

  @Mutation
  saveListDataMutation(data: any[]) {
    this.listData = data || [];
  }

  @Mutation
  addListDataMutation(data: any[] = []) {
    this.listData.push(...(data || []));
  }

  @Mutation
  setSearchConditionMutation({ key = "", value = "" } = {}) {
    if (!key && !value) {
      this.searchCondition = defaultSearchInstance();
    } else {
      this.searchCondition[key] = value;
    }
  }
  @Mutation
  setOpenFilterFlagMutation(data: boolean) {
    this.openFilterFlag = data ?? false;
  }

  // 获取筛选数据
  @Action
  async getFilterDataAction() {
    const data = await queryRequest({
      query: queryPatternForStock,
      variables: { input: {} }
    });
    this.setFilterDataMutation(data);
  }

  @Action
  async queryHubDiameterAction(variables: any) {
    let data = await queryRequest({
      query: queryHubDiameter,
      variables
    });
    // 尺寸从大到小排序
    data = data.sort((a, b) => b - a);
    this.setHubDiameterDataMutation(data);
  }

  @Action
  async queryTyreInventoryQuantityList(variables: any) {
    let data = await queryRequest({
      query: queryTyreInventoryQuantityList,
      variables
    });
    data = data.map(o => {
      (o.list ??= []).sort((a, b) => b.count - a.count);
      return o;
    });
    data.sort((a, b) => b.count - a.count);
    // console.log(data);
    return data;
  }
}
